import axios from 'axios';

import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  }
});

export interface Project {
  id: number;
  name: string;
}

export interface EmployeeWithProjects {
  id: number;
  name: string;
  surname: string;
  projects: Project[];
}

export interface EmployeeAttendanceToday {
  name: string;
  surname: string;
  first_check_in: string | null;
  last_check_out: string | null;
}

export interface DashboardStats {
  activeEmployees: number;
  activeProjects: number;
  thisMonthProjects: number;
  thisMonthFinishedProjects: number;
  activeEmployeesWithProjects: EmployeeWithProjects[];
  availableProjects: Project[];
  totalEmployeesOnVacationToday: number;
  leaveRequests: number;
  totalPublicHolidaysThisMonth: number;
}

export const dashboardService = {
  getStats: async (): Promise<DashboardStats> => {
    const response = await api.get('/dashboard/stats');
    return response.data.data;
  },

  getEmployeesAttendanceToday: async (): Promise<EmployeeAttendanceToday[]> => {
    const response = await api.get('/dashboard/employees-attendance-today');
    return response.data.data;
  }
}; 